<template>
  <Vue3Lottie
    v-if="!completed"
    ref="lottieElement"
    :auto-play="false"
    :loop="false"
    :speed="2"
    class="fireworks"
    :animation-data="animation"
    @on-complete="handleComplete"
  />
</template>
<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie';
import animation from './particles.json';

interface Props {
  delay: number;
}
const props = defineProps({
  delay: null
});

const lottieElement = ref(null);

const completed = ref<boolean>(false);

const handleComplete = () => {
  completed.value = true;
};

const { start: startDelayEffect } = useTimeoutFn(
  () => {
    lottieElement.value.play();
  },
  props.delay,
  { immediate: false }
);

onMounted(() => {
  startDelayEffect();
});
</script>
<style lang="scss" scoped>
.fireworks {
  position: absolute;
  z-index: 0;
  top: 5rem;
  width: 100%;
  height: auto;
  pointer-events: none;
}
</style>
